'use strict';

module.exports = /*@ngInject*/
function() {
    return {
        link: function(scope, element, attrs) {
            element.bind('click', function() {
                jQuery('.currency-panel').slideUp();
            });
        }
    };
};
